/**
 * @flow
 * @relayHash 6c672142593c9a1971426a98b05b4e24
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ReportEditingStatusInput = {
  user: string,
  object: string,
  clientMutationId?: ?string,
};
export type ReportEditingStatusMutationVariables = {|
  input: ReportEditingStatusInput
|};
export type ReportEditingStatusMutationResponse = {|
  +ReportEditingStatus: ?{|
    +sessions: ?$ReadOnlyArray<?{|
      +id: string,
      +user: string,
      +object: string,
    |}>,
    +clientMutationId: ?string,
    +error: ?string,
  |}
|};
export type ReportEditingStatusMutation = {|
  variables: ReportEditingStatusMutationVariables,
  response: ReportEditingStatusMutationResponse,
|};
*/


/*
mutation ReportEditingStatusMutation(
  $input: ReportEditingStatusInput!
) {
  ReportEditingStatus(input: $input) {
    sessions {
      id
      user
      object
    }
    clientMutationId
    error
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ReportEditingStatusInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "ReportEditingStatus",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ReportEditingStatusInput!"
      }
    ],
    "concreteType": "ReportEditingStatusPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "sessions",
        "storageKey": null,
        "args": null,
        "concreteType": "UserSession",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "user",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "object",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ReportEditingStatusMutation",
  "id": null,
  "text": "mutation ReportEditingStatusMutation(\n  $input: ReportEditingStatusInput!\n) {\n  ReportEditingStatus(input: $input) {\n    sessions {\n      id\n      user\n      object\n    }\n    clientMutationId\n    error\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ReportEditingStatusMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ReportEditingStatusMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1db07cf5ebe2f33dc5df017d900d970c';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/ReportEditingStatusMutation.graphql.js